import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {PatientService} from 'src/app/patient-management/services/patient.service';
import {CautionStatus} from 'src/app/helpers/enums';
import {MatSnackBar} from '@angular/material';

@Component({
    selector: 'app-mark-caution-button',
    templateUrl: 'mark-caution-button.component.html',
    styleUrls: ['mark-caution-button.component.scss'],
})
export class MarkCautionButtonComponent implements OnInit {
    @Input() CautionStatus: string;
    @Input() PatientId: string;
    @Input() context: 'whiteboard' | 'patient-record' = 'patient-record'; // Default to patient-record
    @Output() StatusChanged = new EventEmitter<string>();
    markedCaution = false;

    constructor(
        public patientService: PatientService,
        private snackBar: MatSnackBar,
    ) {}

    ngOnInit() {
        this.markedCaution = this.CautionStatus === CautionStatus.Caution;
    }

    toggleCautionStatus() {
        this.patientService.toggleCautionStatus(this.PatientId).subscribe(
            result => {
                this.markedCaution = !this.markedCaution;
                this.StatusChanged.emit();
            },
            error => {
                this.snackBar.open('Error updating caution status', 'Close', {
                    duration: 2000,
                });
            }
        );
    }
}
